// b2b-draft-order.js
document.addEventListener('DOMContentLoaded', () => {
    const addToCartForms = document.querySelectorAll('form[action$="/cart/add"]'); // Selektor ggf. anpassen

    addToCartForms.forEach(form => {
        form.addEventListener('submit', async function(event) {
            let isB2BCustomer = false;
            let customerId = null;

            // Prüfen, ob Kunde eingeloggt ist und B2B-Tag hat
            if (window.Shopify && window.Shopify.customer) {
                customerId = window.Shopify.customer.id; // Shopify stellt dies bereit, wenn Kunde eingeloggt
                if (window.Shopify.customer.tags) {
                    isB2BCustomer = window.Shopify.customer.tags.some(tag => tag.trim().toLowerCase() === 'b2b');
                }
            }
            // Alternative, falls du Tags anders bereitstellst (z.B. über ein data-Attribut im Theme)
            // const b2bMetaElement = document.querySelector('meta[name="is-b2b-customer"]');
            // if (b2bMetaElement && b2bMetaElement.content === 'true') {
            //    isB2BCustomer = true;
            //    const customerIdMeta = document.querySelector('meta[name="customer-id"]');
            //    if (customerIdMeta) customerId = customerIdMeta.content;
            // }


            if (!isB2BCustomer) {
                console.log('Kein B2B-Kunde, Standard-Warenkorb wird verwendet.');
                return true; // Standard-Formularübermittlung zulassen
            }

            event.preventDefault(); // Standard-Aktion verhindern für B2B
            console.log('B2B-Kunde erkannt. Erstelle Draft Order...');

            const formData = new FormData(form);
            const variantId = formData.get('id');
            const quantity = formData.get('quantity') || 1;
            const shopDomain = window.Shopify.shop; // z.B. dein-store.myshopify.com

            const submitButton = form.querySelector('[type="submit"], button[name="add"]');
            if (submitButton) submitButton.disabled = true;
            const buttonText = submitButton ? submitButton.innerText : '';
            if (submitButton) submitButton.innerText = 'Wird verarbeitet...';


            try {
                // Der App Proxy URL-Pfad, den du im Partner Dashboard konfigurierst
                // z.B. /apps/b2bproxy/b2b-add-to-cart
                const response = await fetch(`/apps/b2b-app/proxy/b2b-add-to-cart?shop=${shopDomain}`, { // Passe `/apps/b2b-app` an deinen Proxy-Pfad an
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        variantId: variantId,
                        quantity: parseInt(quantity, 10),
                        customerId: customerId // customerId an Backend senden
                    }),
                });

                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.innerText = buttonText;
                }

                if (response.ok) {
                    const data = await response.json();
                    if (data.invoice_url) {
                        window.location.href = data.invoice_url;
                    } else {
                        console.error('Fehler vom Backend:', data.error || 'Unbekannter Fehler');
                        alert('Fehler: Artikel konnte nicht zum B2B-Warenkorb hinzugefügt werden. ' + (data.error || ''));
                        // Fallback: form.submit(); // Standard-Warenkorb als Notlösung?
                    }
                } else {
                    const errorData = await response.json();
                    console.error('B2B Hinzufügen fehlgeschlagen:', response.status, errorData);
                    alert('Fehler: Konnte B2B-Anfrage nicht verarbeiten. ' + (errorData.error || errorData.details || response.statusText));
                    // Fallback: form.submit();
                }
            } catch (error) {
                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.innerText = buttonText;
                }
                console.error('Netzwerk- oder Skriptfehler im B2B-Prozess:', error);
                alert('Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.');
                // Fallback: form.submit();
            }
        });
    });
});
